/*
  Shared shape for a storefront product.

  Supabase columns and the local fallback in data/stonesData.js use
  different names, so everything the customer-facing pages render goes
  through mapDbProduct() first. The shop and the cart both need it, so it
  lives here rather than inside either one.
*/

export const PLANET_EMOJI = {
  Sun: '☀️',
  Moon: '🌙',
  Mars: '🔴',
  Mercury: '💚',
  Jupiter: '🟡',
  Venus: '💗',
  Saturn: '🟣',
  Rahu: '🟠',
  Ketu: '🔵',
};

export const getEmojiForPlanet = (planet) => PLANET_EMOJI[planet] || '💎';

/* Premium is stored as a plain tag ("Premium"), so the match is
   case- and space-insensitive — a stray "premium " in the admin form
   shouldn't quietly cost the badge. */
export const isPremium = (product) =>
  (product?.tags || []).some(
    (tag) => String(tag).trim().toLowerCase() === 'premium'
  );

export const mapDbProduct = (p) => ({
  id: p.product_code,
  name: p.name,
  planet: p.planet,
  category: p.category,
  price: p.price,
  originalPrice: p.original_price,
  image: p.image_url,
  emoji: getEmojiForPlanet(p.planet),
  rating: p.rating || 0,
  reviews: p.review_count || 0,
  inStock: p.in_stock,
  stock: p.stock_quantity ?? null,
  tags: p.tags || [],
  description: p.description,
  // Keep the Supabase uuid for order_items.product_id.
  supabaseId: p.id,
});
